import { useContext } from 'react'
import { Outlet } from 'react-router-dom'

import { FeatureFlags } from '../../models/FeatureFlags'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import InspectionCacheProvider from '../../providers/DviCacheProvider/InspectionCacheProvider'
import { DviListProviderCacheWrapper } from '../../providers/DviListProvider/DviListProviderCacheWrapper'
import { DviListProviderWrapper } from '../../providers/DviListProvider/DviListProviderWrapper'
import { ReplicacheProvider } from '../../providers/ReplicacheProvider/ReplicacheProvider'

export default function ReplicacheContainer() {
  const { featureFlags } = useContext(AppContext)
  if (featureFlags && featureFlags[FeatureFlags.ReplicacheDvi]) {
    return (
      <ReplicacheProvider>
        <InspectionCacheProvider>
          <DviListProviderCacheWrapper>
            <Outlet />
          </DviListProviderCacheWrapper>
        </InspectionCacheProvider>
      </ReplicacheProvider>
    )
  }
  return (
    <DviListProviderWrapper>
      <Outlet />
    </DviListProviderWrapper>
  )
}
